<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="desserts"
    :single-select="singleSelect"
    item-key="id"
    show-select
    :items-per-page="10"
    :footer-props="{
      'items-per-page-options': [10, 25],
    }"
    style="padding: 25px"
  >
    <template v-slot:top>
      <div>
        <div>
          <v-toolbar style="box-shadow: none !important">
            <v-toolbar-title>
              <b>{{ title }}</b>
            </v-toolbar-title>
          </v-toolbar>

          <div style="padding: 15px 25px 10px 27px">
            <v-layout row>
              <v-flex md8>
                <!-- <v-btn
                  color="primary"
                  v-on:click="send()"
                  style="margin: 0px 10px"
                  depressed
                  small
                >
                  Send to Approver
                </v-btn> -->

                <v-btn class="ml-1" small depressed v-on:click="formSearch">
                  Filter
                </v-btn>

                <v-btn class="ml-1" small depressed v-on:click="refreshAll">
                  Refresh
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1 white--text"
                  color="orange"
                  small
                  depressed
                  v-on:click="rejectMaterialConfirm('', 'CAT')"
                >
                  Return
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1"
                  color="error"
                  small
                  depressed
                  v-on:click="rejectMaterialConfirm('', 'RJT')"
                >
                  Reject
                </v-btn>

                <v-btn
                  :disabled="selected.length < 1"
                  class="ml-1 white--text"
                  color="#26a69a"
                  small
                  depressed
                  v-on:click="approvalProcess()"
                >
                  Approve
                </v-btn>
              </v-flex>

              <v-flex md4>
                <v-text-field
                  label=""
                  v-model="val"
                  placeholder="Enter Your Keywords"
                  solo
                  v-on:keyup.enter="getMaterial()"
                  append-icon="search"
                  @click:append="getMaterial()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>

      <v-dialog v-model="loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading Data..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="form_search" max-width="500px">
        <v-card>
          <v-card-title> Filter List </v-card-title>
          <v-card-text>
            <div style="padding: 10px">
              <label> Status </label>
              <v-select
                item-text="STATUS_NAME"
                item-value="STATUS_ID"
                v-model="filter_status"
                :items="list_status"
                label="Choose Status"
                solo
              ></v-select>

              <div>
                <label>Start Date</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>

              <div>
                <label>End Date</label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="Choose Date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div align="right">
              <v-btn
                rounded
                depressed
                class="mr-2"
                @click="form_search = false"
              >
                Close
              </v-btn>

              <v-btn
                color="primary"
                rounded
                depressed
                :loading="loading"
                v-on:click="getMaterial()"
              >
                Search
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="dialogDetailMaterial"
        v-model="dialogDetailMaterial"
        max-width="80%"
        scrollable
      >
        <detail-material
          :data="detail_data"
          @closeDialog="dialogDetailMaterial = false"
        ></detail-material>
      </v-dialog>

      <v-dialog
        v-if="dialogFeedBack"
        v-model="dialogFeedBack"
        max-width="500"
        scrollable
      >
        <feedback
          :data="feedback_data"
          @closeDialog="dialogFeedBack = false"
        ></feedback>
      </v-dialog>

      <v-dialog
        v-model="dialogConfirm"
        v-if="dialogConfirm"
        scrollable
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-text class="pt-5">
            <div class="text-h6">
              {{ confirm_title }}
            </div>
            <div class="mb-5" style="font-size: 15px">
              {{ confirm_text }}
            </div>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="feedback"
                  placeholder="Enter Feedback"
                  solo
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn depressed @click="dialogConfirm = false">
              Close
            </v-btn>
            <v-btn
              color="primary"
              depressed
              class="white--text"
              @click="rejectMaterialProcess()"
              :loading="loading_confirm"
            >
              Process
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.open"
        :timeout="snackbar.timeout ? snackbar.timeout : 6000"
        top
      >
        {{ snackbar.message_text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :color="snackbar.button_type ? snackbar.button_type : 'primary'"
            v-bind="attrs"
            @click="snackbar.open = false"
          >
            {{ snackbar.button_text ? snackbar.button_text : "Close" }}
          </v-btn>
        </template>
      </v-snackbar>
    </template>

    <template v-slot:item.action="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <div style="position: relative">
            <v-btn text v-on="on" :disabled="selected.length > 1">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>

            <div v-if="item.feedback" class="dot"></div>
          </div>
        </template>
        <v-card>
          <v-list>
            <v-list-item-group>
              <v-list-item @click="openDialogFeedback(item)">
                <v-list-item-title style="width: 150px">
                  <div v-if="item.feedback" class="dot2"></div>
                  <v-icon color="#009688" class="menu-icon"
                    >mdi-comment-edit</v-icon
                  >
                  Feedback
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-on:click="openModalDetail(item)">
                <v-list-item-title>
                  <v-icon color="primary" class="menu-icon"
                    >mdi-file-document</v-icon
                  >
                  Detail
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-on:click="rejectMaterialConfirm(item, 'CAT')">
                <v-list-item-title>
                  <v-icon color="orange" class="menu-icon"
                    >mdi-file-arrow-left-right</v-icon
                  >
                  Return
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-on:click="rejectMaterialConfirm(item, 'RJT')">
                <v-list-item-title>
                  <v-icon color="red" class="menu-icon">mdi-file-remove</v-icon>
                  Reject
                </v-list-item-title>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item v-on:click="approvalProcess(item)">
                <v-list-item-title>
                  <v-icon
                    color="#26a69a"
                    class="menu-icon"
                    style="margin-top: 1px"
                    >mdi-check-circle</v-icon
                  >
                  Approve
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
    </template>

    <template v-slot:item.status="{ item }">
      <status
        :status="item.status"
        :image_available="item.image_available"
        @eventDetail="openModalDetail(item)"
      ></status>
    </template>

    <template v-slot:item.type_input="{ item }">
      <status :status="item.type_input"></status>
    </template>

    <template v-slot:item.possibility_duplicate="{ item }">
      <status :status="item.possibility_duplicate"></status>
    </template>

    <template v-slot:item.basic_data_text="{ item }">
      <BasicDataText :data="item.basic_data_text"></BasicDataText>
    </template>
  </v-data-table>
</template>

<script>
import DetailMaterialVue from "../component/DetailMaterial.vue"
import FeedBackVue from "../component/FeedBack.vue"
import StatusVue from "../component/Status.vue"
import BasicDataText from "../component/BasicDataText.vue"

export default {
  components: {
    "detail-material": DetailMaterialVue,
    feedback: FeedBackVue,
    status: StatusVue,
    BasicDataText,
  },
  data() {
    return {
      name: "Approval",
      title: "Approval List",
      storage: {
        session: true,
      },
      dialog: false,
      dialogConfirm: false,
      notifications: false,
      sound: true,
      widgets: false,
      singleSelect: false,
      selected: [],
      loading: false,
      loadingTable: true,
      val: "",
      log: "",
      tab: "tab-1",
      tab2: "tab-1",
      headers: [
        {
          text: "Action",
          value: "action",
          sortable: false,
          width: 50,
          align: "center",
        },
        { text: "Status", value: "status", width: "180" },
        { text: "Description", value: "description", width: "300" },
        { text: "Request Number", value: "request_no", width: "150" },
        { text: "Request Type", value: "type_input", width: "130" },
        { text: "Requester", value: "request_by", width: "150" },
        { text: "Request Date", value: "request_date", width: "160" },
        { text: "Material Number", value: "material_number", width: "160" },
        { text: "INC Code", value: "inc_code", width: "130" },
        { text: "Item Name", value: "inc_name", width: "250" },
        { text: "Basic Data Text", value: "basic_data_text", width: "400" },
        { text: "Manufacturer", value: "manufacturer", width: "150" },
        { text: "Part Number", value: "part_number", width: "150" },
        { text: "Plant", value: "plant_name", width: "150" },
        { text: "Base Unit", value: "base_unit", width: "150" },
        { text: "Remarks", value: "remarks", width: "200" },
        {
          text: "Possibility Duplicate",
          value: "possibility_duplicate",
          width: "170",
        },
      ],
      desserts: [],
      list_message: [],
      list_message2: [],
      user_id: "",
      email_approval: "noreply@sinarmas.com",
      user_request: "",
      departement_id: "",
      username: "",
      user_approval: "",
      request_no: "",
      message: "",
      requester_message: "",
      requester_date: "",
      modal_message: "",
      modal_detail: false,
      detail: [],
      form_search: false,
      menu: false,
      menu2: false,
      user_cataloguer: "",
      list_approval_user: [],

      //Dropdown......................................
      list_status: [{ STATUS_ID: "APP1", STATUS_NAME: "Request Approval" }],
      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
      storage_server: atob(localStorage.getItem("server")),

      dialogDetailMaterial: false,
      dialogFeedBack: false,
      detail_data: null,
      feedback_data: null,
      feedback: null,
      confirm_title: null,
      confirm_text: null,
      selected_status: null,
      selected_item: null,
      loading_confirm: false,

      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
    }
  },
  mounted() {
    this.getMaterial()
    if (this.storage_role != "APP1") {
      this.$router.push("/login")
    }
  },
  methods: {
    getMaterial() {
      var self = this
      var val = self.val
      var url = self.base_url + "material/getdata/approval"
      this.loading = true

      this.axios
        .post(url, {
          param: val,
          user_id: self.storage_user_id,
          filter_status: self.filter_status,
          filter_startdate: self.date,
          filter_enddate: self.date2,
        })
        .then(function(response) {
          self.desserts = response.data
          self.form_search = false
          self.loadingTable = false
          self.selected = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModalDetail(item) {
      this.detail_data = item
      this.dialogDetailMaterial = true
    },
    formSearch() {
      this.form_search = true
    },
    openDialogFeedback(item) {
      this.dialogFeedBack = true
      this.feedback_data = item
    },
    approvalProcess(item = null) {
      const id = this.selected.length > 0 ? this.selectedRows() : item.id

      this.$dialog.confirm({
        text: "Are you sure you want to process this item ?",
        title: "Approval Process",
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "primary",
            text: "Yes",
            handle: () => {
              var self = this
              var url = self.base_url + "material/process/approval_process"
              this.axios
                .post(url, {
                  id: id,
                  user_id: self.storage_user_id,
                })
                .then(function(response) {
                  if (response.status === 200) {
                    self.snackbar = {
                      open: true,
                      message_text: "Material approval success",
                      button_type: "primary",
                      button_text: "Ok",
                    }
                    self.getMaterial()
                  }
                })
                .catch(() => {
                  self.snackbar = {
                    open: true,
                    message_text: "Material approval failed",
                    button_type: "error",
                  }
                })
            },
          },
        },
      })
    },
    rejectMaterialConfirm(item = null, status) {
      // var checkRows = this.checkRows()
      // if (checkRows > 0) {
      //   this.snackbar = {
      //     open: true,
      //     message_text: `There are ${checkRows} items that cannot be processed because the status has been process`,
      //     button_type: "error",
      //   }
      //   return false
      // }

      if (status === "RJT") {
        this.confirm_text = `Are you sure, you want to reject this item ?`
        this.confirm_title = "Reject material item"
      } else if (status === "CAT") {
        this.confirm_text = `Are you sure, you want to return this item ?`
        this.confirm_title = "Return to requester"
      }

      this.selected_item = item
      this.selected_status = status
      this.dialogConfirm = true
    },
    rejectMaterialProcess() {
      var self = this
      const id =
        self.selected.length > 0 ? self.selectedRows() : self.selected_item.id

      if (!self.feedback) {
        self.snackbar = {
          open: true,
          message_text: `Feedback cannot be empty`,
          button_type: "error",
        }
        return false
      }

      self.loading_confirm = true
      var url = self.base_url + "material/process/reject"

      this.axios
        .post(url, {
          id: id,
          user_id: self.storage_user_id,
          status: self.selected_status,
          feedback: self.feedback,
          role: this.storage_role,
        })
        .then(function(response) {
          if (response.status === 200) {
            self.snackbar = {
              open: true,
              message_text: `${self.confirm_title} success`,
              button_type: "primary",
              button_text: "Ok",
            }
            self.feedback = null
            self.dialogConfirm = false
            self.loading_confirm = false
            self.getMaterial()
          }
        })
        .catch(() => {
          self.snackbar = {
            open: true,
            message_text: `${self.confirm_title} failed`,
            button_type: "error",
          }
        })
    },
    edit(item) {
      var id = item.id
      var server = "GEMS"
      this.$router.push({
        path: "/addRegister/" + btoa(server) + "/edit/" + btoa(id),
      })
    },
    refreshAll() {
      this.val = ""
      this.filter_status = ""
      this.filter_server = ""
      this.date = ""
      this.date2 = ""
      this.getMaterial()
    },
    checkRows() {
      var total = this.selected.length
      var a = 0
      for (var i = 0; i < total; i++) {
        if (
          this.selected[i].status != "REG" &&
          this.selected[i].status != "RJT"
        ) {
          a++
        }
      }
      return a
    },
    selectedRows() {
      var arritem = this.selected
      var item = ""

      if (arritem.length > 0) {
        for (var a = 0; a < arritem.length; a++) {
          item += "," + arritem[a].id
        }
        item = item.substring(1)
      }
      return item
    },
  },
}
</script>

<style>
.menu-icon {
  margin-top: -3px;
  margin-right: 10px;
}

.badge {
  position: absolute;
  margin-top: -1px;
  margin-left: -25px;
}

.dot {
  position: absolute;
  margin-top: -30px;
  margin-left: 38px;
  background-color: red;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.dot2 {
  position: absolute;
  margin-top: -5px;
  margin-left: 23px;
  background-color: red;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}
</style>
